import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-youtubegaming',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>YouTube Gaming icon</title><path d="M24 13.2v-6l-6-3.6-6 3.6-6-3.6-6 3.6v6l12 7.2zM8.4 10.8H6v2.4H4.8v-2.4H2.4V9.6h2.4V7.2H6v2.4h2.4zm7.2 2.4a1.2 1.2 0 01-1.2-1.2c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2zm3.6-2.4A1.2 1.2 0 0118 9.6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2 0 .66-.54 1.2-1.2 1.2Z"/></svg>`,
    styles: []
})
export class SimpleIconsYoutubegamingComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF0000';
    @Input() className: string = 'simple-icons-youtubegaming'
    constructor() {}
    ngOnInit(): void {}
}
